<template>
	<div>
		<deal-pack-view
			:deal-pack="dealPack"
		/>
	</div>
</template>

<script>

	import DealPackView from '@/components/dealPacks/DealPackView';
	import routeParams  from '@/mixins/routeParams';
	import api          from '@/services/api';

	export default {
		metaInfo () {
			if (!this.getDealPackTitle) {
				return false;
			}
			return {
				title: this.getDealPackTitle
			};
		},
		layout: 'v2default',
		components: {
			DealPackView
		},
		mixins: [routeParams],
		data: () => ({
			dealPack: {}
		}),
		computed: {
			getDealPackTitle () {
				return this.dealPack?.title || '';
			},
			getBreadcrumbs () {
				return [
					{
						path: '/my-deals',
						text: 'My Deals'
					},
					{
						path: this.getDealPackRoute,
						text: this.getDealPackTitle
					}
				].filter(Boolean);
			}
		},
		created: function () {
			this.setDealPack();
		},
		methods: {
			async setDealPack () {
				const dealPack = await api.dealPacks.getDealPackById({
					dealPackId: this.getDealPackId
				});
				if (!dealPack) {
					this.$store.commit('ui/showError');
					return false;
				}

				const teacherProfile = await api.teacherProfiles.getTeacherProfileById({
					profileId: dealPack.teacherProfileId
				});

        if (!teacherProfile) {
					this.$store.commit('ui/showError');
					return false;
				}

				dealPack.teacherProfile = teacherProfile;

				this.dealPack = dealPack;
				this.$store.commit('ui/setBreadcrumbs', {
					breadcrumbs: this.getBreadcrumbs
				});
				this.$store.commit('ui/setLoadingIsHidden');
			}
		}
	};

</script>

<style lang="scss" scoped>
	[data-route] {}
</style>
